import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, Routes } from 'react-router-dom';

import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { GenerateReportsStep } from './generate-reports/steps/generate-reports-step/GenerateReportsStep';
import { SuccessStep } from './generate-reports/steps/success-step/SuccessStep';

export const GenerateReportsPage = () => {
  const returnToPath = urlBuilder.reports.path;
  const basePath = urlBuilder.reportsNew.path;

  return (
    <FlowContextProvider routePath="" basePath={basePath} returnToPath={returnToPath}>
      <Routes>
        <Route
          path="start"
          element={
            <StepWrapper name="start">
              <GenerateReportsStep />
            </StepWrapper>
          }
        />
        <Route
          path="success"
          element={<StepWrapper name="success">{stepProps => <SuccessStep {...stepProps} />}</StepWrapper>}
        />
      </Routes>
    </FlowContextProvider>
  );
};
